import { observable, computed, toJS } from 'mobx';
import { useEffect } from 'react';
import Toast from '@src/components/toast';
import { noop } from '@src/utils/common-util';

class AudioControllerStore {
  updateStateTimer = null;
  onSelect = null;

  constructor(props = {}) {
    Object.assign(this, props);
    this.onSelect = this.onSelect || noop;
  }

  @observable audioList = [];
  @observable activeIndex = 0;

  @observable canplay = false;
  @observable playing = false;
  @observable currentTime = 0;
  @observable duration = 0;
  @observable soundCloudAudio = null;

  @computed
  get currentAudio() {
    return this.audioList[this.activeIndex];
  }

  @computed
  get currentAudioProgress() {
    const _p = (this.currentTime / this.duration) * 100;
    return !isNaN(_p) ? _p : 0;
  }

  // 进度条步长
  @computed
  get audioProgressStep() {
    return 100 / this.duration;
  }

  onCanPlayTrack = () => {
    this.canplay = true;
  };

  audioProgressChange = e => {
    const progress = e.target.value;
    let _ct = Number(((progress * this.duration) / 100).toFixed(6));
    this.currentTime = _ct;
    this.soundCloudAudio.setTime(_ct);
  };

  select = index => {
    if (index !== this.activeIndex) {
      this.canplay = false;
      this.activeIndex = index;
      this.onSelect(toJS(this.currentAudio), this.activeIndex);
    }
  };

  prevAudio = () => {
    if (this.activeIndex > 0) {
      this.select(this.activeIndex - 1);
      return;
    }
    this.select(this.audioList.length - 1);
  };

  nextAudio = () => {
    if (this.activeIndex < this.audioList.length - 1) {
      this.select(this.activeIndex + 1);
      return;
    }
    this.select(0);
  };

  playAudio = async playing => {
    playing = typeof playing === 'boolean' ? playing : !this.playing;
    if (playing) {
      try {
        const res = this.soundCloudAudio.play();
        if (res?.then) {
          await res;
        }
      } catch (err) {
        // Toast.fail('音频播放失败，请稍后重试');
      }
    } else {
      this.soundCloudAudio.pause();
    }
  };

  use({ playing, currentTime, duration, soundCloudAudio }) {
    // console.log('use', playing, currentTime, duration, soundCloudAudio);
    this.playing = playing;
    this.currentTime = currentTime;
    // this.duration = this.currentAudio?.duration || 0;
    this.duration = duration || soundCloudAudio.audio.duration || 0;

    this.soundCloudAudio = soundCloudAudio;

    useEffect(() => {
      const errorHandler = e => {
        Toast.fail('音频播放失败，请稍后重试');
      };
      const endedHandler = () => {
        setTimeout(() => {
          this.nextAudio();
        }, 1000);
      };
      soundCloudAudio.audio.addEventListener('error', errorHandler);
      soundCloudAudio.audio.addEventListener('ended', endedHandler);

      return () => {
        soundCloudAudio.stop();
        soundCloudAudio.audio.removeEventListener('error', errorHandler);
        soundCloudAudio.audio.removeEventListener('ended', endedHandler);
      };
    }, []);
  }
}

export default AudioControllerStore;
